import { render, staticRenderFns } from "./ExhibitionInfo.vue?vue&type=template&id=1c79ebd1&scoped=true"
import script from "./ExhibitionInfo.vue?vue&type=script&lang=js"
export * from "./ExhibitionInfo.vue?vue&type=script&lang=js"
import style0 from "./ExhibitionInfo.vue?vue&type=style&index=0&id=1c79ebd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c79ebd1",
  null
  
)

export default component.exports